import React, { Component, Fragment } from 'react';
import { trustedHTMLHandler } from '../../components/Forms/Templates/QuestionDetails/trustedHTMLHandler';
import { mergeStyleSets } from '@fluentui/react';
import getToggleablePlugins from './getToggleablePlugins';
import _ from 'lodash';
import {
    createRibbonPlugin,
    createUpdateContentPlugin,
    getButtons,
    Ribbon,
    Rooster,
    UpdateMode,
    AllButtonKeys,
    createPasteOptionPlugin,
    createEmojiPlugin,
} from 'roosterjs-react';


const classNames = mergeStyleSets({
    editorContainer: {
        width: '100%',
        height:250,
        minWidth: 200,
        flexGrow: 1,
        flexShrink: 1,
        position: 'relative'
    },
    editor: {
        overflow: 'auto',
        padding: 10,
        outline: 'none',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        borderTop: '1px solid #eee'
    }
});

class Editor extends Component {
    
    constructor(props) {
        super(props);

        this.ribbonPlugin = createRibbonPlugin();
        this.emojiPlugin = createEmojiPlugin();
        this.updateContentPlugin = createUpdateContentPlugin(UpdateMode.OnUserInput, this.onUpdate);
        this.updateContentPlugin2 = createUpdateContentPlugin(UpdateMode.OnContentChangedEvent, this.onUpdate);

        var options = [0,
            1,
            2,
            7,
            20,
            11,
            12,
            13,
            14,
            15,
            16,
            23,
            //24,
            28,
            29,
            30];
        this.mainWindowButtons = getButtons([
            ...options,
        ]);
        this.update = _.debounce(this.update, 500);
        this.state = {
            initState: props.data,
            editorCreator: null,
            showContentModelRibbon: false,
        };
    }

    update = content => {
        this.props.updateCallback(content)
    }

    onUpdate = (content) => {
        this.update(content)
     };

     getPlugins() {
         const plugins = [
             ...getToggleablePlugins(),
            this.ribbonPlugin,
            this.emojiPlugin,
             this.updateContentPlugin,
             this.updateContentPlugin2
        ];

        return plugins;
    }


    render() {
        const allPlugins = this.getPlugins();
        this.updateContentPlugin.forceUpdate();
        return (
             <div className="flexcolumn width100">
                <Ribbon
                    id="RibbonIcons"
                    buttons={this.mainWindowButtons}
                    plugin={this.ribbonPlugin}
                />
                <div className="quiz-container-wrapper">
                <div id="EditorContainer" className={classNames.editorContainer}>
                    <Rooster
                            className='rooster-editor'
                        plugins={allPlugins}
                        trustedHTMLHandler={trustedHTMLHandler}
                        initialContent={this.state.initState}
                        editorCreator={this.state.editorCreator}
                    />
                    </div>
                </div>
            </div>
        );
    }
}
export default Editor;